class BottomBarMenuPaymentsButtonListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('click', context.selector, function (){


            if($('.passengers_panel').length > 0)
                $('#payment_tab').trigger('click');
        });

    }

}